var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbQareas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292969 8.05921C0.29332 8.24502 0.330298 8.42894 0.401789 8.60045C0.473281 8.77196 0.577882 8.92769 0.70961 9.05874C0.841339 9.18979 0.997611 9.29359 1.16949 9.36419C1.34136 9.4348 1.52547 9.47083 1.71128 9.47022H2.41534V6.6482H1.71128C1.52547 6.64759 1.34136 6.68362 1.16949 6.75422C0.997611 6.82483 0.841339 6.92862 0.70961 7.05967C0.577882 7.19072 0.473281 7.34646 0.401789 7.51797C0.330298 7.68948 0.29332 7.8734 0.292969 8.05921Z",
    fill: "url(#paint0_linear_712_1021)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19275 9.10575V8.38476H9.79769V9.61487H10.8831V8.38476H11.6766C11.7451 8.57272 11.8697 8.73506 12.0336 8.84977C12.1975 8.96448 12.3927 9.02601 12.5927 9.02601C12.7928 9.02601 12.988 8.96448 13.1519 8.84977C13.3158 8.73506 13.4404 8.57272 13.5089 8.38476H14.284V9.61487H15.3694V8.38476H16.2051C16.2736 8.57272 16.3982 8.73506 16.5621 8.84977C16.726 8.96448 16.9212 9.02601 17.1213 9.02601C17.3213 9.02601 17.5165 8.96448 17.6804 8.84977C17.8443 8.73506 17.969 8.57272 18.0375 8.38476H18.8426V9.61487H19.928V8.38476H20.7331C20.8016 8.57272 20.9263 8.73506 21.0902 8.84977C21.2541 8.96448 21.4493 9.02601 21.6493 9.02601C21.8494 9.02601 22.0446 8.96448 22.2085 8.84977C22.3724 8.73506 22.497 8.57272 22.5655 8.38476H23.3289V9.61487H24.4143V8.38476H26.825C26.921 8.38476 27.013 8.34664 27.0808 8.27879C27.1487 8.21094 27.1868 8.11892 27.1868 8.02296C27.1868 7.92701 27.1487 7.83499 27.0808 7.76714C27.013 7.69929 26.921 7.66117 26.825 7.66117H24.4143V6.50342H23.3289V7.66117H22.5453C22.4697 7.48632 22.3446 7.33743 22.1854 7.23282C22.0261 7.12822 21.8398 7.07248 21.6493 7.07248C21.4588 7.07248 21.2725 7.12822 21.1133 7.23282C20.9541 7.33743 20.829 7.48632 20.7533 7.66117H19.928V6.50342H18.8426V7.66117H18.0172C17.9416 7.48632 17.8165 7.33741 17.6573 7.23281C17.4981 7.1282 17.3117 7.07246 17.1213 7.07246C16.9308 7.07246 16.7444 7.1282 16.5852 7.23281C16.426 7.33741 16.3009 7.48632 16.2253 7.66117H15.3694V6.50342H14.284V7.66117H13.4887C13.4131 7.48632 13.288 7.33743 13.1288 7.23282C12.9696 7.12822 12.7832 7.07248 12.5927 7.07248C12.4023 7.07248 12.2159 7.12822 12.0567 7.23282C11.8975 7.33743 11.7724 7.48632 11.6968 7.66117H10.8831V6.50342H9.79769V7.66117H7.19275V6.99264C7.19275 6.79286 7.00078 6.64814 6.80092 6.64814H3.14062V9.47015H6.80092C7.00078 9.47015 7.19275 9.30553 7.19275 9.10575Z",
    fill: "url(#paint1_linear_712_1021)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 4.2946C11.8164 4.39056 11.8545 4.48258 11.9224 4.55043C11.9902 4.61828 12.0822 4.6564 12.1782 4.6564C12.2742 4.6564 12.3662 4.61828 12.434 4.55043C12.5019 4.48258 12.54 4.39056 12.54 4.2946C12.54 3.94858 12.6877 3.79474 12.9111 3.56196C13.1663 3.29619 13.4839 2.96536 13.4839 2.32824C13.4839 1.69111 13.1663 1.36028 12.9111 1.09451C12.6877 0.861656 12.54 0.707892 12.54 0.361797C12.54 0.265842 12.5019 0.173818 12.434 0.105968C12.3662 0.0381178 12.2742 0 12.1782 0C12.0822 0 11.9902 0.0381178 11.9224 0.105968C11.8545 0.173818 11.8164 0.265842 11.8164 0.361797C11.8164 0.998994 12.134 1.32975 12.3891 1.5956C12.6126 1.82838 12.7603 1.98214 12.7603 2.32824C12.7603 2.67433 12.6126 2.82809 12.3891 3.06087C12.134 3.32687 11.8164 3.65748 11.8164 4.2946Z",
    fill: "url(#paint2_linear_712_1021)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 4.2946C14.9219 4.39056 14.96 4.48258 15.0278 4.55043C15.0957 4.61828 15.1877 4.6564 15.2837 4.6564C15.3796 4.6564 15.4717 4.61828 15.5395 4.55043C15.6074 4.48258 15.6455 4.39056 15.6455 4.2946C15.6455 3.94858 15.7931 3.79474 16.0166 3.56196C16.2717 3.29619 16.5893 2.96536 16.5893 2.32824C16.5893 1.69111 16.2717 1.36028 16.017 1.09451C15.7934 0.861656 15.6458 0.707892 15.6458 0.361797C15.6458 0.265842 15.6077 0.173818 15.5399 0.105968C15.472 0.0381178 15.38 0 15.284 0C15.1881 0 15.0961 0.0381178 15.0282 0.105968C14.9604 0.173818 14.9222 0.265842 14.9222 0.361797C14.9222 0.998994 15.2398 1.32975 15.495 1.5956C15.7184 1.82838 15.8661 1.98214 15.8661 2.32824C15.8661 2.67433 15.7184 2.82809 15.495 3.06087C15.2395 3.32687 14.9219 3.65748 14.9219 4.2946Z",
    fill: "url(#paint3_linear_712_1021)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 4.2946C17.957 4.39056 17.9951 4.48258 18.063 4.55043C18.1309 4.61828 18.2229 4.6564 18.3188 4.6564C18.4148 4.6564 18.5068 4.61828 18.5747 4.55043C18.6425 4.48258 18.6806 4.39056 18.6806 4.2946C18.6806 3.94858 18.8282 3.79474 19.0518 3.56196C19.3069 3.29619 19.6245 2.96536 19.6245 2.32824C19.6245 1.69111 19.3069 1.36028 19.0518 1.09451C18.8282 0.861656 18.6806 0.707892 18.6806 0.361797C18.6806 0.265842 18.6425 0.173818 18.5747 0.105968C18.5068 0.0381178 18.4148 0 18.3188 0C18.2229 0 18.1309 0.0381178 18.063 0.105968C17.9951 0.173818 17.957 0.265842 17.957 0.361797C17.957 0.998994 18.2746 1.32975 18.5298 1.5956C18.7532 1.82838 18.9009 1.98214 18.9009 2.32824C18.9009 2.67433 18.7532 2.82809 18.5298 3.06087C18.2746 3.32687 17.957 3.65748 17.957 4.2946Z",
    fill: "url(#paint4_linear_712_1021)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 4.2946C21.0625 4.39056 21.1006 4.48258 21.1685 4.55043C21.2363 4.61828 21.3283 4.6564 21.4243 4.6564C21.5203 4.6564 21.6123 4.61828 21.6801 4.55043C21.748 4.48258 21.7861 4.39056 21.7861 4.2946C21.7861 3.94858 21.9337 3.79474 22.1572 3.56196C22.4124 3.29619 22.7299 2.96536 22.7299 2.32824C22.7299 1.69111 22.4124 1.36028 22.1572 1.09451C21.9337 0.861656 21.7861 0.707892 21.7861 0.361797C21.7861 0.265842 21.748 0.173818 21.6801 0.105968C21.6123 0.0381178 21.5203 0 21.4243 0C21.3283 0 21.2363 0.0381178 21.1685 0.105968C21.1006 0.173818 21.0625 0.265842 21.0625 0.361797C21.0625 0.998994 21.38 1.32975 21.6352 1.5956C21.8587 1.82838 22.0063 1.98214 22.0063 2.32824C22.0063 2.67433 21.8587 2.82809 21.6352 3.06087C21.3802 3.32687 21.0625 3.65748 21.0625 4.2946Z",
    fill: "url(#paint5_linear_712_1021)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6816 12.2922H6.10547V14.6801H28.6816V12.2922Z",
    fill: "url(#paint6_linear_712_1021)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7694 20.8306H23.0382C26.068 20.8306 28.5509 18.4428 28.706 15.4037H6.10156C6.2567 18.4428 8.7395 20.8306 11.7694 20.8306ZM10.0505 16.7062H16.1007C16.1966 16.7062 16.2887 16.7443 16.3565 16.8121C16.4244 16.88 16.4625 16.972 16.4625 17.068C16.4625 17.1639 16.4244 17.2559 16.3565 17.3238C16.2887 17.3916 16.1966 17.4297 16.1007 17.4297H10.0505C9.95455 17.4297 9.86252 17.3916 9.79467 17.3238C9.72682 17.2559 9.68871 17.1639 9.68871 17.068C9.68871 16.972 9.72682 16.88 9.79467 16.8121C9.86252 16.7443 9.95455 16.7062 10.0505 16.7062ZM8.22755 16.7062H8.57531C8.67127 16.7062 8.76329 16.7443 8.83114 16.8121C8.89899 16.88 8.93711 16.972 8.93711 17.068C8.93711 17.1639 8.89899 17.2559 8.83114 17.3238C8.76329 17.3916 8.67127 17.4297 8.57531 17.4297H8.22755C8.1316 17.4297 8.03957 17.3916 7.97172 17.3238C7.90387 17.2559 7.86576 17.1639 7.86576 17.068C7.86576 16.972 7.90387 16.88 7.97172 16.8121C8.03957 16.7443 8.1316 16.7062 8.22755 16.7062Z",
    fill: "url(#paint7_linear_712_1021)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7691 21.5541C11.3627 21.5541 10.9572 21.5153 10.5582 21.4384L7.02734 33.9999H8.69096L12.2014 21.5541H11.7691Z",
    fill: "url(#paint8_linear_712_1021)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0385 21.5541H22.6055L26.1166 33.9999H27.7802L24.2498 21.4384C23.8507 21.5153 23.4451 21.554 23.0385 21.5541Z",
    fill: "url(#paint9_linear_712_1021)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4188 26.9812L10.9844 28.5007H23.8231L23.3886 26.9812H11.4188Z",
    fill: "url(#paint10_linear_712_1021)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_1021",
    x1: 1.35416,
    y1: 6.64819,
    x2: 1.35416,
    y2: 11.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_712_1021",
    x1: 15.1637,
    y1: 6.50342,
    x2: 15.1637,
    y2: 11.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_712_1021",
    x1: 12.6501,
    y1: 0,
    x2: 12.6501,
    y2: 8.00318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_712_1021",
    x1: 15.7556,
    y1: 0,
    x2: 15.7556,
    y2: 8.00318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_712_1021",
    x1: 18.7908,
    y1: 0,
    x2: 18.7908,
    y2: 8.00318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_712_1021",
    x1: 21.8962,
    y1: 0,
    x2: 21.8962,
    y2: 8.00318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_712_1021",
    x1: 17.3935,
    y1: 12.2922,
    x2: 17.3935,
    y2: 16.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_712_1021",
    x1: 17.4038,
    y1: 15.4037,
    x2: 17.4038,
    y2: 24.7313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_712_1021",
    x1: 9.61437,
    y1: 21.4384,
    x2: 9.61437,
    y2: 43.0286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_712_1021",
    x1: 25.1929,
    y1: 21.4384,
    x2: 25.1929,
    y2: 43.0286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_712_1021",
    x1: 17.4037,
    y1: 26.9812,
    x2: 17.4037,
    y2: 29.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbQareas);
export default __webpack_public_path__ + "static/media/BBQareas.ebdc65782ac960b0f81ed8b712f7d287.svg";
export { ForwardRef as ReactComponent };